import React, { memo, useState } from "react"
import Box from "@material-ui/core/Box"
import clsx from "clsx"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import { useDispatch, useSelector } from "react-redux"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import { Collapse, Divider, Link, List, ListItem, ListItemIcon, ListItemText, Tooltip } from "@material-ui/core"
import { AddShoppingCartOutlined, BlockOutlined, CheckBoxOutlined, ExpandLessOutlined, ExpandMoreOutlined, InboxOutlined } from "@material-ui/icons"
import globalUseStyles from "@/globalUseStyles"
import { useNavigate } from "react-router-dom"
import modalStatusHandler from "@/redux/actions/modalAction"
import { resetActivateProcess } from "@/redux/actions/activateProjectProcessAction"

const useStyles = makeStyles((theme) => ({
    sidebarDropdownWrapper: {
        backgroundColor: theme.palette.sparcaDarkGrey.main,
        borderRadius: 0,
    },
    sidebarDropdownWrapperEmpty: {
        height: 0,
    },
    sidebarDropdown: {
        borderRadius: 0,
    },
    productHeader: {
        backgroundColor: theme.palette.sparcaLightBlue.main,
        color: "#ffffff",
        textAlign: "center",
        padding: theme.spacing(1),
    },
    productContent: {
        padding: theme.spacing(3, 1),
    },
    buttonWrapper: {
        color: "#ffffff",
    },
    button: {
        fontSize: "14px",
        textAlign: "center",
    },
    blueButton: {
        backgroundColor: theme.palette.sparcaDarkBlue.main,
        color: "#ffffff",
        "&:hover": { backgroundColor: theme.palette.sparcaDarkBlue.main, color: "#ffffff" },
    },
    colorGreen: {
        color: 'green'
    },
    colorRed: {
        color: 'red'
    },
    productTitle: {
        fontSize: 14
    }
}))


const MuiListItem = withStyles((theme) => ({
    root: {
        "&$selected": {
            backgroundColor: "red",
            color: "white",
            "& .MuiListItemIcon-root": {
                color: "white"
            }
        },
        "&$selected:hover": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            "& .MuiListItemIcon-root": {
                color: "white"
            }
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            "& .MuiSvgIcon-root": {
                color: "white !important"
            }
        }
    },
    selected: {}
}))(ListItem);



const SidebarDropdown = memo(() => {
    const productData = useSelector((state) => state.productReducer)
    const { customerDataCulture, sparcaProducts } = productData
    const classes = useStyles()
    const globalClasses = globalUseStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleActivateProject = () => {
        dispatch(
            modalStatusHandler({
                modalProjectId: null,
                currentStep: 1,
                modalShow: true,
            })
        )
        dispatch(resetActivateProcess)
    }

    const renderItem = (item) => {
        let link = null
        const activeStatus = item.status && (item.status === "active" || item.Status === "pending-cancel")
        link = `${process.env.CC_MAIN_SITE}${item.productPageLink}`

        const indexOfSpace = item.productName.includes('SPARCA') ? item.productName.indexOf(' ') : -1;
        let productName = "";

        if (indexOfSpace === -1) {
            productName = item.productName
        } else {
            productName = item.productName.substring(indexOfSpace + 1);
        }


        return (
            <MuiListItem key={item.productId} button className={classes.nested} onClick={() => {
                activeStatus ? handleActivateProject() : window.open(link)
            }}>
                <ListItemIcon>
                    {activeStatus ? <CheckBoxOutlined className={classes.colorGreen} /> : <BlockOutlined className={classes.colorRed} />}
                </ListItemIcon>
                <ListItemText className={classes.productTitle} primary={<Typography className={classes.productTitle}>{productName}</Typography>} />
            </MuiListItem>
        )
    }


    const customerDataCultureContent = customerDataCulture.length && customerDataCulture.map((item) => renderItem(item))
    const sparcaProductsContent = sparcaProducts.length && sparcaProducts.map((item) => renderItem(item))

    const [collapse, setCollapse] = useState(true)

    return (
        <>
            <Tooltip title="SPARCA Products" placement="right-end">
                <MuiListItem button onClick={() => { setCollapse(!collapse) }}>
                    <ListItemIcon>
                        <InboxOutlined />
                    </ListItemIcon>
                    <ListItemText primary="Products" />
                    {collapse ? <ExpandMoreOutlined /> : <ExpandLessOutlined />}
                </MuiListItem>
            </Tooltip>
            <Collapse in={!collapse} timeout="auto" unmountOnExit>
                <List component="div" disablePadding className={classes.subList}>
                    {sparcaProductsContent.length && sparcaProductsContent}
                    <Divider />
                    {customerDataCultureContent.length && customerDataCultureContent}
                </List>
            </Collapse>
        </>
    )
})

export default SidebarDropdown
